export function contactCategoryMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      contactCategoryId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateContactCategoryId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyContactCategorys(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateContactCategoryId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function contactCategoryMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, contactCategoryId: json.result.objectId},
  };
}